/**
 * SbTourMessage — centered greeting panel for a tour's starting (Welcome) and
 * ending (Finish) steps (steps with no highlight target). Shows a brand icon,
 * heading, message, a primary action and a subtle secondary action.
 *
 * Presentational only — text, icon and handlers come from the caller.
 */

import React from "react";
import { Typography } from "antd";
import SbButton, { BUTTON_TYPE } from "../SbButton/SbButton";
import { TourMessageStyled, TourMessageIconStyled } from "./SbTour.styles";

const { Title, Paragraph } = Typography;

const SbTourMessage = ({
  icon,
  title,
  description,
  primaryText,
  secondaryText,
  onPrimary,
  onSecondary,
}) => (
  <TourMessageStyled vertical align="center" gap="middle">
    {icon && <TourMessageIconStyled size={56} icon={icon} />}
    <Title level={4}>{title}</Title>
    <Paragraph type="secondary">{description}</Paragraph>
    <SbButton buttonType={BUTTON_TYPE.PRIMARY} size="large" block onClick={onPrimary}>
      {primaryText}
    </SbButton>
    {secondaryText && (
      <SbButton type="link" onClick={onSecondary}>
        {secondaryText}
      </SbButton>
    )}
  </TourMessageStyled>
);

export default SbTourMessage;
